import { Injectable } from '@angular/core';
import { State, StateToken, Action, StateContext } from '@ngxs/store';
import { RefreshState } from '../refresh/refresh-actions';
import { SetJobStatus } from './job-status-action';

export const JOB_STATUS_TOKEN = new StateToken<any[]>('JobStatus');

@State({
    name: JOB_STATUS_TOKEN,
    defaults: []
})
@Injectable()
export class JobStatusState {
    @Action(RefreshState)
    refresh(ctx: StateContext<any>, action: RefreshState) {
        if (action.data.name === JOB_STATUS_TOKEN.getName()) {
            ctx.setState(action.data.state);
        }
    }

    @Action(SetJobStatus)
    set(ctx: StateContext<any>, action: SetJobStatus) {
        ctx.setState(action.data);
    }
}
